import React, { memo } from 'react';
import { ModalProps } from '../navigation/Modals';
import BaseSidebar from './BaseSidebar';

const Sidebar: React.FC<ModalProps> = (props) => (
  <BaseSidebar {...props} ratio={1} />
);
export default memo(Sidebar);
